import { makeStyles } from '@material-ui/core'
import { Fade, Modal } from '@mui/material'
import Backdrop from '@mui/material/Backdrop'
import CloseButton from 'src/components/common/CloseButton'
import { COLORS } from 'src/utils/Themes/colors'

const VehicleInformationModal = ({
  open,
  setOpen,
  buyType,
  vehicleType,
  handleClick,
}) => {
  const handleClose = () => {
    setOpen(false)
  }
  const classes = useStyles()
  return (
    <Modal
      open={open}
      onClose={handleClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={open}>
        <div className={classes.modalStyle}>
          <CloseButton
            title='Close'
            handleClose={handleClose}
            classname={classes.clsBtn}
            id='closeButton'
          />
          <div>
            <div>This page is for {buyType}</div>
            <div>
              In order to purchase {vehicleType}{' '}
              <span
                onClick={handleClick}
                className={classes.clickHereText}
                id='clickHereText'
              >
                click here
              </span>
            </div>
          </div>
        </div>
      </Fade>
    </Modal>
  )
}

export default VehicleInformationModal

const useStyles = makeStyles({
  modalStyle: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    background: '#FFFFFF',
    padding: 50,
  },
  clickHereText: {
    cursor: 'pointer',
    color: COLORS.DARK_PINK,
  },
  clsBtn: {
    position: 'absolute',
    right: 0,
    top: 0,
  },
})
